import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureDataFactoryIcon = props => (
  <Icon viewBox="0 0 18 18" w="full" h="full" color="inherit" {...props}>
    <defs>
      <linearGradient
        id="f710a364-083f-494c-9d96-89b92ee2d5a8"
        x1="0.5"
        y1="9.77"
        x2="9"
        y2="9.77"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#000000" />
        <stop offset="0.07" stopColor="#000000" />
        <stop offset="0.36" stopColor="#000000" />
        <stop offset="0.52" stopColor="#000000" />
        <stop offset="0.64" stopColor="#000000" />
        <stop offset="0.81" stopColor="#000000" />
        <stop offset="0.99" stopColor="#000000" />
      </linearGradient>
    </defs>
    <g>
      <path
        d="M13.25,10.48V6.57a.14.14,0,0,0-.24-.1l-4,4L4.85,14.63V17.5H16.93a.56.56,0,0,0,.57-.57V6.57a.14.14,0,0,0-.24-.1Z"
        fill="currentColor"
      />
      <path
        d="M4.75,3.58C2.4,3.58.5,2.89.5,2V7.67h0v9.26a.56.56,0,0,0,.57.57H9V2C9,2.89,7.1,3.58,4.75,3.58Z"
        fill="currentColor"
        //stroke="currentColor"
      />
      <rect
        x="12.91"
        y="12.97"
        width="2.27"
        height="2.27"
        rx="0.28"
        fill="#ffffff"
      />
      <rect
        x="8.97"
        y="12.97"
        width="2.27"
        height="2.27"
        rx="0.28"
        fill="#ffffff"
      />
      <rect
        x="5.03"
        y="12.97"
        width="2.27"
        height="2.27"
        rx="0.28"
        fill="#ffffff"
      />
      <path
        d="M9,2c0,.85-1.9,1.54-4.25,1.54S.5,2.89.5,2,2.4.5,4.75.5,9,1.19,9,2"
        fill="#ebebeb"
      />
      <path
        d="M8,1.91c0,.55-1.46,1-3.26,1s-3.26-.43-3.26-1S3,.94,4.75.94,8,1.37,8,1.91"
        fill="#8f8f94"
      />
      <path
        d="M4.75,2.14a8.07,8.07,0,0,0-2.58.37,7.64,7.64,0,0,0,2.58.38,7.64,7.64,0,0,0,2.58-.38A8.07,8.07,0,0,0,4.75,2.14Z"
        fill="#f0f0f5"
      />
    </g>
  </Icon>
);
